module.exports = __webpack_public_path__ + "img/member_7.62fd4abb.jpg";